import * as SelectPrimitive from "@radix-ui/react-select";
import { DocumentBlobKind, DocumentBlobKindList } from "@bitory-gmbh/bsm";
import { ComponentProps } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";

export function DocumentBlobKindSelect({
  availableDocumentBlobKinds = DocumentBlobKindList,
  value,
  onValueChange,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  availableDocumentBlobKinds?: DocumentBlobKind[];
}) {
  const modValue = value === DocumentBlobKind.All ? "all" : value;
  const onModValueChange = (val: string) => {
    if (!onValueChange) return;

    if (val === "all") {
      onValueChange(DocumentBlobKind.All);
      return;
    }

    onValueChange(val as DocumentBlobKind);
  };

  return (
    <Select {...props} value={modValue} onValueChange={onModValueChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Art des Dokuments auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {availableDocumentBlobKinds.map((kind) =>
            kind === DocumentBlobKind.All ? (
              <SelectItem key="all" value="all">
                {t("Alle")}
              </SelectItem>
            ) : (
              <SelectItem key={kind} value={kind}>
                {t(kind)}
              </SelectItem>
            ),
          )}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
